<div class="product-badge-wrapper">
  <ul
    class="d-flex justify-content-around justify-content-sm-around justify-content-md-start justify-content-lg-start justify-content-xl-start align-items-center badge-list"
  >
    @for (badge of badges; track badge; let i = $index) {
    <li
      data-bs-toggle="modal"
      [attr.data-bs-target]="'#descModal' + i"
    >
      <div
        class="d-flex flex-column flex-sm-column flex-md-row flex-lg-row flex-xl-row justify-content-center align-items-center badge-list-content"
      >
        <img [src]="badge?.icon" class="badge-icon" />

        <h3>{{ badge?.title }}</h3>
      </div>

      <!-- Modal -->
      <div
        class="modal fade"
        [id]="'descModal' + i"
        tabindex="-1"
        aria-labelledby="descModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <img [src]="badge?.icon" class="badge-icon" />
              <h5 class="modal-title" id="descModalLabel">
                {{ badge?.title }}
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              {{ badge?.description }}
            </div>
          </div>
        </div>
      </div>
    </li>
    }
  </ul>
</div>
